import script from "./Dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./Dialog.vue?vue&type=script&setup=true&lang=js"

import "./Dialog.vue?vue&type=style&index=0&id=3e5b7832&lang=scss"

const __exports__ = script;

export default __exports__